<template>
	<div>
		<div class="col-12">
			<form @submit.prevent="onSubmit" class="mb-5">
				<div class="row">
					<div class="col">
						<div class="lightgray-content p-3 rounded mb-2">
							<div class="row flex-nowrap">

							<div class="agency-detail-column">
								<div class="form-group input-content">
									<label>Agency Logo</label>
									<picture-input 
											ref="pictureInput"
											accept="image/jpeg,image/png" 
											size="10" 
											button-class="button"
											:custom-strings="{
											upload: '<h1>Bummer!</h1>',
											drag: 'Drag or click to upload an image'
											}"
											@change="onChange"
											:prefill="organization_data.image_fill">
										</picture-input>
								</div>
							</div>
							
							<div class="col">
								<div class="form-group input-content">
									<div class="form-group input-content">
										<label>Agency Name</label>
										<input placeholder="Name" type="text" v-model="org_data.name" 
										
										class="form-control" v-validate="'required'" name="name">
										<span class="input-error-msg">{{ errors.first('name') }}</span>
									</div>
									<div class="form-group input-content">
									<label>Agency Name As Shown On the App</label>
										<input placeholder="Name" type="text" v-model="org_data.display_name" 
										
										class="form-control"  name="internal_name">
										<!-- <span class="input-error-msg">{{ errors.first('name') }}</span> -->
									</div>
									<div class="form-group input-content">
										<phone-country-code
										:rule="'not_required'"
										:section="'existin-provider'"
										:country_codes="country_codes"
										:form="org_data"
										@countryInput="countryInput"/>
									</div>
								</div>
							</div><!--col-->


							<div class="col">
								<div class="form-group input-content" >
									<label>Year founded</label>
									<multiselect v-model="org_data.year_founded" :options="years" :style=" {'margin-left': '0px'}"></multiselect>
									<span class="input-error-msg">{{ errors.first('year_founded') }}</span>
								</div>
								<div class="form-group input-content">
									<label>Became customer on</label>
									
									<datetime  v-model="org_data.became_costumer" hidden-name="became_costumer" name="became-costumer" placeholder="Became customer on" ></datetime>
									<span class="input-error-msg">{{ errors.first('became_costumer') }}</span>
								</div>
								<div class="form-group input-content">
									<label>Purchased hours</label>
									<input placeholder="Purchased hours" type="text" v-model="org_data.purchased_hours" class="form-control" v-validate="" name="purchased_hours">
									<span class="input-error-msg">{{ errors.first('purchased_hours') }}</span>
								</div>
								<div class="form-group input-content">
									<label>Code</label>
									<input placeholder="Internal code" type="text" v-model="org_data.code" class="form-control" v-validate="" name="code">
									<span class="input-error-msg">{{ errors.first('code') }}</span>
								</div>

								<div class="form-group">
									<div class="checkbox-container squared">
										<input id="checkbox-can-download-certificate" type="checkbox" v-model="org_data.can_download_certificate"/>
										<label for="checkbox-can-download-certificate" style="width:auto;">HHAs can download certificate from APP</label>
									</div>
								</div>
							</div><!--col-->

							<div class="col">
								<h6><u>Agency Contact Detail</u></h6>
								<div class="form-group input-content">
									<label>Contact Name</label>
									<input placeholder="Name" type="text" v-model="org_data.contact_name" 
									class="form-control" name="agency_contact_name">
								</div>
								<div class="form-group input-content">
									<label>Contact Job Title</label>
									<input placeholder="Job Title" type="text" v-model="org_data.contact_job_title" 
									class="form-control" name="agency_contact_job_title">
								</div>
								<div class="form-group input-content">
									<label>Contact Email</label>
										<input placeholder="Contact Email" type="text" v-model="org_data.contact_email" class="form-control" name="agency_contact_email">
								</div>
							
								<div class="form-group input-content">
									<label>Contact Phone number</label>
									<input placeholder="Phone number" type="text" v-model="org_data.contact_phone" class="form-control"  name="phone">
								</div>
							</div><!--col-->


							</div><!--row-->
						</div><!--lightgray_content-->
						<div class="text-right">
							<button type="submit" class="large-button button">Create</button>
						</div>
					</div><!--col-->
				</div><!--row-->
			</form>
		</div><!--col-->
	</div>
</template>
<script>
import { EventBus } from './../../../../event_bus.js';
import PictureInput from 'vue-picture-input';
import PhoneCountryCode from '../../../shared/inputs/PhoneCountryCode'
export default {
	props: {
		organization_data: Object
	},
	components: {
		PictureInput,
		PhoneCountryCode,
	},
	data: function(){
		return{
			org_data: this.organization_data,
			colour: '#194d33',
			years:[],
			integration_list:[],
			country_codes:[],

		}
	},
	created : function(){
		this.getCountries();
		this.getPartners();
		for(var i = 1900; i<2018;i++){
			this.years.push(i);
		}
	},
	methods : {
		onSubmit : function(){
			this.$validator.validateAll().then((result) => {
				if(result){
					 this.$emit('onSubmit',  this.org_data)
				}
			});
		},
		onChange (image) {
			if (image) {
				this.organization_data.image = image;
			}
		},
		getPartners: function(){
			var params = {
					// id : this.id
			}
			this.$store.dispatch('getOrganizationPartners', params).then((res) => {
					Object.keys(res.data).map((key) => {
						this.integration_list.push(res.data[key])
					})
					this.integration_list.push({id:0, name: 'None'})
					if(this.organization_data.partner_id){
						this.org.partner_id = this.integration_list.find(
						elem => elem.id == this.organization_data.partner_id
						)
						this.show_integration_section = true
					}
					
			
			}).catch((error) => {
					console.log(error);
			});
		},
		getCountries : function(){
			this.$store.dispatch('getCountries', {}).then((res) => {
			
				this.country_codes = res.data.data;
			}).catch((error) =>{	
				console.log(error);
			});
		},
		countryInput: function(val){
				this.organization_data.country_code = val
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/admin/organization/shared/OrganizationDetailForm.vue